<template>
    <sui-modal
            v-model="open"
            style="z-index: 21000;"
            :size="'large'"
            :closable="false"
            closeIcon
    >
        <sui-modal-content style="padding: 0; background-color: black;">
            <youtube :video-id="videoId"></youtube>
        </sui-modal-content>
    </sui-modal>
</template>

<script>
    import Vue from 'vue'

    import VueYoutube from 'vue-youtube'

    Vue.use(VueYoutube);

    export default {
        props: {
            isOpen: {
                type: Boolean,
                default: false
            },
            videoId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                open: this.isOpen
            }
        },
        computed: {},
        methods: {},

        components: {},

        watch: {
            isOpen(newVal) {
                this.open = newVal;
            },
            open(newVal) {
                if (newVal !== this.isOpen)
                    this.$emit('update:isOpen', newVal)
            }
        }
    }
</script>

<style>
    iframe {
        width: 100%;
        height: 650px;
    }
</style>
